import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';

export function HerdTotalAnimalsDisplay({
    herdId,
    latestBefore,
}: {
    herdId: string;
    latestBefore: Date | null;
}) {
    const snapshot = useSnapshot({
        snapshotType: 'Herd',
        parentId: herdId,
        shelfLife: null,
        cursorTimeOverride: latestBefore ?? undefined,
    });

    return (
        <StatDisplay
            id="herd-from-total-animals"
            name="From Total Animals"
            value={snapshot?.totalAnimals}
            emptyStateMessage="No past data"
        />
    );
}
